module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-9-abe6783b91b108cb823affae40620b10.png";